export default __webpack_public_path__ + "static/media/fslogin.6840ae5c.png";